import { Icon } from '@shared/models/icon.model';

export interface ConfirmationConfig {
  message: string;
  headerTitle?: string;
  type?: ConfirmationType;
  icon?: Icon;
  warnAction?: boolean;
  mainActionText?: string;
  cancelActionText?: string;
  checkboxOption?: string;
  enableCancel?: boolean;
  enableAction?: boolean;
  enableTitle?: boolean;
  textAreaText?: string;
  disableCloseDialog?: boolean;
  isTextAreaRequired?: boolean;
}

export enum ConfirmationType {
  DestructiveAction,
  NonDestructiveAction,
  Informative,
}

const DEFAULT_CONFIG: ConfirmationConfig = {
  message: '',
  headerTitle: '',
  type: ConfirmationType.DestructiveAction,
  warnAction: true,
};

export class Confirmation implements ConfirmationConfig {
  constructor(
    public type: ConfirmationType = ConfirmationType.NonDestructiveAction,
    public headerTitle: string = '',
    public message: string = '',
    public mainActionText?: string,
    public cancelActionText?: string,
    public warnAction: boolean = false,
    public checkboxOption?: string,
    public icon?: Icon,
    public enableCancel: boolean = true,
    public enableAction: boolean = true,
    public enableTitle: boolean = true,
    public textAreaText?: string,
    public disableCloseDialog: boolean = false,
    public isTextAreaRequired: boolean = true
  ) {}
}

export class IconicConfirmation extends Confirmation {
  config: ConfirmationConfig;
  constructor(config: ConfirmationConfig) {
    const {
      type,
      headerTitle,
      message,
      mainActionText,
      cancelActionText,
      warnAction,
      checkboxOption,
      icon,
      enableCancel,
      enableAction,
      enableTitle,
      textAreaText,
      disableCloseDialog,
      isTextAreaRequired,
    } = Object.assign({}, DEFAULT_CONFIG, config);
    super(
      type,
      headerTitle,
      message,
      mainActionText,
      cancelActionText,
      warnAction,
      checkboxOption,
      icon,
      enableCancel,
      enableAction,
      enableTitle,
      textAreaText,
      disableCloseDialog,
      isTextAreaRequired
    );
  }
}
